import { object, string, mixed } from "yup"

import BusinessInfo from "./views/BusinessInfo"
import AdditionalDocuments from "./views/AdditionalDocuments"
import OtherInfo from "./views/OtherInfo"

export default [
  {
    id: "business_info",
    component: BusinessInfo,
    initialValues: {
      company_name: "",
      rc_number: "",
      proprietor_name: "",
      registration_date: "",
      email: "",
      phone: "",
    },
    validationSchema: object().shape({
      company_name: string().required("Business Name is Required"),
      proprietor_name: string().required("Required"),
      registration_date: string().required("Required"),
      rc_number: string()
        .matches(
          /^(BN|RC)\d{1,9}$/,
          "Invalid format. Use BN1234567 or RC1234567"
        )
        .required("This field is required"),
      email: string()
        .email("Must be a valid email address")
        .required("Required"),
      phone: string()
        .matches(/^[0-9]{11}$/, "This phone number is Invalid")
        .required("Required"),
    }),
    actionLabel: "Next",
  },
  {
    id: "other_info",
    component: OtherInfo,
    initialValues: {
      business_address: "",
      country: "",
      state: "",
      city: "",
    },
    validationSchema: object().shape({
      business_address: string().required("What is your business address?"),
      country: string().required("Required"),
      state: string().required("Required"),
      city: string().required("Required"),
    }),
    actionLabel: "Next",
  },
  {
    id: "additional_documents",
    component: AdditionalDocuments,
    initialValues: {
      certificate_of_registration: "",
      certificate_of_registration_name: "",
    },
    validationSchema: object().shape({
      certificate_of_registration: string().required("A file is required"),
    }),
    actionLabel: "Confirm",
  },
]
